<template>
	<div class="customer">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
			<top-nevleft></top-nevleft>
		 <b-col>
			 <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Customer Dashboard</h5>
				</b-col>				
			</b-row>
       <!-- <div class="breadcrumb-section mb-5">
            <b-container fluid>
                <b-row>
                    <b-col class="text-left">
                        <h5 class="mt-3 mb-3">MY Wallet</h5>		
                    </b-col>
                    <b-col class="text-right">
                        <h6 class="mt-3 mb-3">HOME / ACCOUNT / Wallet</h6>		
                    </b-col>
                </b-row>
            </b-container>
        </div>-->
			<wallet-list></wallet-list>
		
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
		<!-- <quickview :modaldata="$root.quickview_data"></quickview> -->
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
//import ProductSwiper from "@/components/product-swiper.vue";
//import Quickview from "@/components/quickview.vue";
import TreeviewPage from "@/components/common/nevleft.vue";
import WalletList from "@/components/wallet.vue";
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		//"product-swiper": ProductSwiper,
		//"quickview": Quickview,
		"top-nevleft": TreeviewPage,
		"wallet-list": WalletList,
	},
	mounted(){
        //this.initload();
	},
	data() {
		return{
			statusSidebar: false,
            modal_data: {
                price: 0,
                special_price: 0
			},
			slide:0,
			related_products: [],
			url: this.$root.WEBURL+'customer-orders',
		};
	},
	methods: {
		burgerMenuSidebar() {
		  this.statusSidebar = !this.statusSidebar;
		},
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.url, {
                accesskey: self.$session.get('access_key'),
                products: 1
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.related_products = response.data.result.related_products;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
.col-form-label-sm{
padding:0px;
margin:0px;}
.customer{
	.walletIcon{
		float:left;
		width: 7%;
		.walletFont{
			font-size:50px;
			color:#a437e9;
		}
	}
	.welletText{
			width: 93%;
		.heading{ font-size:23px;}
	}
	.amountTextColor{ color:#a437e9; } 
	
	.walletHistory{
	width: 40%;
    font-size: 14px;
		
		.walletAc{border-top: 1px solid #c6c6c6;
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.walletAp{
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.hlink{
		margin-left:10px;
		color:#a437e9;
		}
	}

}

</style>